import React, { useState, useEffect } from "react";
import {
  Table,
  Button,
  Select,
  Input,
  Form,
  Row,
  Col,
  Space,
  Typography,
} from "antd";
import { FaEye } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { getSchools } from "../features/schools/schoolSlice";
import { Link } from "react-router-dom";
import SchoolPopupModal from "../components/SchoolPopupModal";
import moment from "moment";
import { ExportOutlined, PlusOutlined } from "@ant-design/icons";
import { CSVLink } from "react-csv";
import { getStates } from "../features/statecity/statecitySlice";
import { getUsers } from "../features/cutomers/customerSlice";
import { getBrands } from "../features/brand/brandSlice";
const { Search } = Input;
const { Title } = Typography;

const columns = [
  {
    title: "Serial No",
    dataIndex: "serialNo",
    key: "serialNo",
    render: (text, record, index) => index + 1,
    width: 5,
  },
  {
    title: "UDISE Code",
    dataIndex: "UDISE_Code",
    key: "UDISE_Code",
  },
  {
    title: "School Name",
    dataIndex: "school_name",
    sorter: (a, b) => a.school_name.length - b.school_name.length,
  },
  {
    title: "Principal Name",
    dataIndex: "principal_name",
  },
  {
    title: "Phone No",
    dataIndex: "phone_no",
  },
  {
    title: "District",
    dataIndex: "district",
  },
  {
    title: "State",
    dataIndex: "state",
  },
  {
    title: "Pincode",
    dataIndex: "pincode",
  },
  {
    title: "Created At",
    dataIndex: "createdAt",
    render: (text) => moment(text).format("YYYY-MM-DD"),
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

const csvHeaders = [
  { label: "Sr.No", key: "serialNo" },
  { label: "School Name", key: "school_name" },
  { label: "Principal Name", key: "principal_name" },
  { label: "Phone No", key: "phone_no" },
  { label: "Address", key: "address" },
  { label: "Districts", key: "district" },
  { label: "State", key: "state" },
  { label: "Pincode", key: "pincode" },
  { label: "Created At", key: "createdAt" },
];

const Schools = () => {
  const [open, setOpen] = useState(false);
  const [selectedSchool, setSelectedSchool] = useState(null);
  const [filteredData, setFilteredData] = useState([]);
  const [vcData, setvcData] = useState([]);
  const [vtData, setvtData] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [selectedDistrict, setselectedDistrict] = useState("");
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [filteredAllSchool, setfilteredAllSchool] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [loadingDistricts, setLoadingDistricts] = useState(false);

  const dispatch = useDispatch();
  const [form] = Form.useForm();

  const schoolState = useSelector((state) => state.school.schools);
  const statelistState = useSelector(
    (state) => state.statecity.statelist || []
  );
  const vclistState = useSelector((state) => state.customer.customers || []);
  const classlistState = useSelector((state) => state.brand.brands || []);

  useEffect(() => {
    dispatch(getSchools());
    dispatch(getStates());
    dispatch(getUsers());
    dispatch(getBrands());
  }, [dispatch]);

  useEffect(() => {
    if (schoolState.length > 0 && !initialDataLoaded) {
      handleSubmit();
      setInitialDataLoaded(true);
    }
  }, [schoolState, initialDataLoaded]);

  const showModal = (school) => {
    setSelectedSchool(school);
    setOpen(true);
  };

  const hideModal = () => {
    setOpen(false);
    setSelectedSchool(null);
  };

  const transformedData = filteredAllSchool.map((school) => ({
    ...school,
    action: (
      <Link className="text-primary" onClick={() => showModal(school)}>
        <FaEye />
      </Link>
    ),
  }));

  const handleSearch = (value) => {
    setSearchValue(value);
    const searchString = value.toLowerCase();
    const filteredData = transformedData.filter((school) => {
      return (
        school.school_name.toLowerCase().includes(searchString) ||
        school.principal_name.toLowerCase().includes(searchString) ||
        school.phone_no.toLowerCase().includes(searchString) ||
        school.district.toLowerCase().includes(searchString) ||
        school.state.toLowerCase().includes(searchString) ||
        school.pincode.toLowerCase().includes(searchString)
      );
    });
    setFilteredData(filteredData);
  };

  const handleChange = (value) => {
    handleSearch(value);
  };

  const handleClear = () => {
    setSearchValue("");
    setFilteredData([]);
  };

  useEffect(() => {
    if (selectedState) fetchDistricts(selectedState);
  }, [selectedState]);

  const handleStateChange = (value) => {
    const vcfilterData = vclistState.filter(
      (customer) => customer.state === value
    );
    setvcData(vcfilterData);
    setSelectedState(value);
  };

  const fetchDistricts = async (stateCode) => {
    const vtfilterData = statelistState.filter(
      (distric) => distric.state === stateCode
    );
    setDistrictOptions(vtfilterData);
    setLoadingDistricts(true);
  };

  const handleDistrictChange = (value) => {
    setselectedDistrict(value);
  };

  const handleSubmit = () => {
    console.log(
      "Print all 2 Filter Query Data ---",
      selectedState + " " + selectedDistrict
    );
    console.log("Print School List State ----", schoolState);

    const filteredData = schoolState.filter((school) => {
      const matchesState = selectedState
        ? school.state_code === selectedState
        : true;
      const matchesDistrict = selectedDistrict
        ? school.district === selectedDistrict
        : true;

      return matchesState && matchesDistrict;
    });
    console.log("Print Filter Data ---- ", filteredData);

    setfilteredAllSchool(filteredData);
  };

  const handleClears = () => {
    form.resetFields();
    setSelectedState("");
    setselectedDistrict("");
    setfilteredAllSchool(schoolState);
    setDistrictOptions([]);
  };

  return (
    <div style={{ padding: "20px" }}>
      <Title level={3} className="mb-4">
        All Schools
      </Title>
      <div
        style={{
          marginBottom: 16,
          backgroundColor: "#ffffff",
          border: "1px solid #eef2f6",
          padding: "20px",
          borderRadius: "12px",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.04)",
        }}
      >
        <Row
          justify="space-between"
          align="middle"
          style={{ marginBottom: 16 }}
        >
          <Col>
            <Link to="/admin/add-school">
              <Button type="primary" icon={<PlusOutlined />}>
                Add School
              </Button>
            </Link>
          </Col>
          <Col>
            <Space>
              <Search
                placeholder="Search by"
                style={{ width: 300 }}
                onSearch={handleSearch}
                onChange={handleChange}
              />
              <CSVLink
                data={transformedData}
                headers={csvHeaders}
                filename={`School-List${new Date().toISOString()}.csv`}
              >
                <Button type="primary" icon={<ExportOutlined />}>
                  Export to CSV
                </Button>
              </CSVLink>
            </Space>
          </Col>
        </Row>

        <Form form={form} layout="inline" onFinish={handleSubmit}>
          <Form.Item
            name="state_name"
            rules={[
              {
                required: true,
                message: "Please Select State!",
              },
            ]}
          >
            <Select
              style={{ width: 160, marginRight: 16 }}
              placeholder="Select State"
              onChange={handleStateChange}
            >
              {statelistState.map((i, j) => (
                <Select.Option key={j} value={i.state}>
                  {i.state_name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="district">
            <Select
              style={{ width: 160, marginRight: 16 }}
              placeholder="Select District"
              onChange={handleDistrictChange}
              // loading={loadingDistricts}
              disabled={!selectedState}
            >
              {districtOptions.map((district) =>
                district.district_name.map((districtName, idx) => (
                  <Select.Option key={idx} value={districtName}>
                    {districtName}
                  </Select.Option>
                ))
              )}
            </Select>
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" icon={<FaEye />}>
              View
            </Button>
          </Form.Item>
          <Form.Item>
            <Button type="default" onClick={handleClears}>
              Clear
            </Button>
          </Form.Item>
        </Form>
      </div>

      <Table
        columns={columns}
        className="custom-table"
        dataSource={filteredData.length ? filteredData : transformedData}
        // pagination={{ pageSize: 20 }}
        size="small"
      />

      <SchoolPopupModal
        open={open}
        hideModal={hideModal}
        school={selectedSchool}
      />
    </div>
  );
};

export default Schools;
